module.exports = __webpack_public_path__ + "static/media/howitworksMobile.a7930d59.png";